<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <FiltroLotes />
      <v-flex lg12 sm12 xs12 class="pt-0">
        <div class="mb-3 d-flex flex-wrap">
          <GeneratePDF
            :itemsPerPage="tableLotes.paginate.size"
            :head="tableLotes.header.filter(v => v.value !== 'entidadeSigla')"
            :title="'Lotes'"
            :report-data="searchJSON"
            :disable="tableLotes?.total === 0"
            class="mb-2 mr-2"
          />
          <GenerateExcel
            :itemsPerPage="tableLotes.paginate.size"
            :head="tableLotes.header.filter(v => v.value !== 'entidadeSigla')"
            :title="'Lotes'"
            :report-data="searchJSON"
            :disable="tableLotes?.total === 0"
            class="mb-2"
          />
        </div>

        <!-- Tabela desktop -->
        <v-data-table
          class="d-none d-sm-block"
          :headers="tableLotes.header.filter(v => v.value !== 'entidadeSigla')"
          :items="tableLotes.content"
          :item-key="'id'"
          :loading="tableLotes.isLoading"
          :items-per-page="tableLotes.paginate.size"
          :options.sync="pagination"
          :server-items-length="tableLotes.total"
          :footer-props="{
            showFirstLastPage: true,
            showCurrentPage: true,
            itemsPerPageOptions: [5, 10, 50, tableLotes.total].sort((a, b) => a - b).filter(v => v !== 0)
          }"
        >
          <template #item.id="{ item }"><span>{{ item.id }}</span></template>
          <template #item.graficaNomeFantasia="{ item }"><span>{{ item.graficaNomeFantasia }}</span></template>
          <template #item.situacao="{ item }"><span>{{ item.situacao }}</span></template>
          <template #item.createdDate="{ item }"><span>{{ item.createdDate }}</span></template>

          <template #item.acoes="{ item }">
            <v-btn icon small :ripple="false" @click.stop.prevent="routHistorico(item)">
              <v-icon color="primary" size="middle" title="Histórico do Lote">description</v-icon>
            </v-btn>

            <v-btn
              icon
              small
              :ripple="false"
              v-if="item.situacao === 'Lote Enviado para a Entidade Estudantil'"
              @click.stop.prevent="receberSolicitacao(item)"
            >
              <v-icon color="primary" size="middle" title="Receber Lote do Sindiônibus">arrow_back</v-icon>
            </v-btn>
          </template>
        </v-data-table>

        <!-- Cards mobile -->
        <div class="d-block d-sm-none">
          <v-card
            v-for="item in pagedItems"
            :key="item.id"
            outlined
            class="mb-2 pa-2 cursor-pointer"
            @click="routHistorico(item)"
          >
            <v-row>
              <v-col cols="12">
                <div class="caption">
                  Lote: <span class="font-weight-bold" style="color: #1976d2">{{ item.id }}</span>
                </div>
                <div class="caption">Gráfica: {{ item.graficaNomeFantasia }}</div>
                <div class="caption">Status: {{ item.situacao }}</div>
                <div class="caption">Data: {{ item.createdDate }}</div>
              </v-col>
            
              <v-col cols="12" class="d-flex justify-end">
                <v-btn
                  icon
                  small
                  :ripple="false"
                  v-if="item.situacao === 'Lote Enviado para a Entidade Estudantil'"
                  @click.stop.prevent="receberSolicitacao(item)"
                >
                  <v-icon color="primary" title="Receber Lote do Sindiônibus">arrow_back</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        
          <v-row class="justify-center mt-2 mb-2">
            <v-pagination
              v-model="mobilePage"
              :length="mobileTotalPages"
              @input="onMobilePageChange"
            >
              <template v-slot:item="{ page, isActive, disabled }">
                <v-btn
                  v-if="page === 1 || page === mobileTotalPages || page === mobilePage"
                  :color="isActive ? 'primary' : ''"
                  :disabled="disabled"
                  small
                  @click="$set(mobilePage, page)"
                >
                  {{ page }}
                </v-btn>
                <v-btn
                  v-else-if="page === 'prev'"
                  icon
                  @click="mobilePage > 1 && onMobilePageChange(mobilePage - 1)"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn
                  v-else-if="page === 'next'"
                  icon
                  @click="mobilePage < mobileTotalPages && onMobilePageChange(mobilePage + 1)"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
            </v-pagination>
          </v-row>
        
          <div class="d-flex justify-center align-center mb-1">
            <span class="caption">
              Página {{ mobilePage }} de {{ mobileTotalPages }}
            </span>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <OpenDialogConfirmar
      :openDialog="openDialogConfirmarRecebimento"
      message="Somente confirme o recebimento do Lote se realmente tiver recebido."
      :onClose="onClose"
      :onClick="receberSolicitacoes"
    />
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FiltroLotes from "./FiltroLotes.vue";
import GenerateExcel from "@/components/GenerateExcel.vue";
import GeneratePDF from "@/components/GeneratePDF.vue";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import OpenDialogConfirmar from "@/components/OpenDialogConfirmar.vue";
import EntidadeService from "@/services/sie-pedidos/entidade.service";
import AuthService from "@/services/sie-pedidos/auth.service";
import { router } from "@/router";

const actions = mapActions("siePedidos", [
  "setTableLotesContent",
  "setTableLotesIsLoading",
  "setTableLotesTotals",
  "clearTableLotes",
  "setTableLotesPagination",
]);
const state = mapState("siePedidos", ["tableLotes"]);

export default {
  components: { OpenDialogConfirmar, FiltroLotes, GenerateExcel, GeneratePDF },

  data: () => ({
    pagination: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [] },
    mobilePage: 1,
    mobilePageSize: 5,
    loading: false,
    openDialogConfirmarRecebimento: false,
    itemsSelected: null,
    mobileItems: [],
  }),

  computed: {
    ...state,
    mobileTotalPages() {
      return Math.max(1, Math.ceil(this.tableLotes.total / this.mobilePageSize));
    },
    pagedItems() {
      return this.mobileItems;
    },
  },

  mounted() {
    this.changePagination();
    this.fetchMobilePage(1);
  },

  watch: {
    pagination: {
      handler() {
        this.changePagination();
      },
      deep: true,
    },
    mobilePage(newPage) {
      this.fetchMobilePage(newPage);
    },
  },

  destroyed() {
    this.clearTableLotes();
  },

  methods: {
    changePagination() {
      const { id } = this.$route.params;
      const { page, itemsPerPage, sortBy, sortDesc } = this.pagination;
      let input = { ...this.tableLotes.paginate };
      if (Object.prototype.hasOwnProperty.call(this.$route.query, "situacao")) {
        const { situacao } = this.$route.query;
        input = { ...this.tableLotes.paginate, situacao };
      }
      const sortByKey = sortBy?.length ? sortBy[0] : "id";
      const sortOrder = sortDesc.length ? (sortDesc[0] ? "DESC" : "ASC") : "ASC";
      const paginate = {
        ...this.tableLotes.paginate,
        ...input,
        graficaId: id,
        page: page - 1,
        size: itemsPerPage === "Total" ? this.tableLotes.total : itemsPerPage,
        sortBy: sortByKey,
        sortOrder,
      };
      this.setTableLotesPagination(paginate);
      this.search();
    },

    search() {
      this.setTableLotesIsLoading(true);
      EntidadeService.getListaLotesPorEntidade(this.tableLotes.paginate).subscribe(
        ({ result }) => {
          this.setTableLotesContent(result?.data || []);
          this.setTableLotesTotals(result.totalElements || 0);
          this.setTableLotesIsLoading(false);
        },
        () => {
          this.setTableLotesIsLoading(false);
        }
      );
    },

    fetchMobilePage(page) {
      const { id } = this.$route.params;
      const paginate = {
        ...this.tableLotes.paginate,
        graficaId: id,
        page: page - 1,
        size: this.mobilePageSize,
      };
      this.setTableLotesIsLoading(true);
      EntidadeService.getListaLotesPorEntidade(paginate).subscribe(
        ({ result }) => {
          this.mobileItems = result.data || [];
          this.setTableLotesTotals(result.totalElements || 0);
          this.setTableLotesIsLoading(false);
        },
        () => {
          this.setTableLotesIsLoading(false);
        }
      );
    },

    searchJSON() {
      return new Promise((resolve, reject) => {
        EntidadeService.getListaLotesPorEntidade({ ...this.tableLotes.paginate, size: this.tableLotes.total, page: 0 }).subscribe(
          ({ result }) => {
            const formatted = result.data.map((i) => ({
              graficaNomeFantasia: i.graficaNomeFantasia,
              id: i.id,
              situacao: i.situacao,
              createdDate: FunctionsCommuns.formatBRDateHora(i.createdDate),
            }));
            resolve(formatted);
          },
          (error) => reject(error)
        );
      });
    },

    receberSolicitacao(item) {
      if (item?.id) this.itemsSelected = item;
      this.$nextTick(() => {
        if (this.itemsSelected && this.itemsSelected.situacao === "Lote Enviado para a Entidade Estudantil") {
          this.openDialogConfirmarRecebimento = true;
        } else {
          AuthService.globalStore("error", "Por favor selecionar apenas Lote com Status Lote Enviado para a Entidade Estudantil");
        }
      });
    },

    onClose() {
      this.openDialogConfirmarRecebimento = false;
    },

    receberSolicitacoes() {
      this.loading = true;
      EntidadeService.receberSolicitacaoSindionibus(this.itemsSelected.id).subscribe(
        {
          next: () => {
            AuthService.globalStore("success", "Solicitações Recebidas!");
            this.search();
          },
          error: (error) => {
            const msg = error?.response?.data?.message || "Erro ao receber";
            AuthService.globalStore("error", msg);
          },
        }
      ).add(() => {
        this.loading = false;
      });
    },

    routHistorico(item) {
      router.push(`/carteira-macrorregiao/entidade/lotes/historico/${item.id}`);
    },

    onMobilePageChange(page) {
      this.mobilePage = page;
    },

    ...actions,
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
